export const floatDiff = [
  {
    MIN_DECIMAL: 1,
    MAX_DECIMAL: 2,
    MIN_NUMBER: 1,
    MAX_NUMBER: 99,
  },
  {
    MIN_DECIMAL: 2,
    MAX_DECIMAL: 3,
    MIN_NUMBER: 1,
    MAX_NUMBER: 100,
  },
  {
    MIN_DECIMAL: 3,
    MAX_DECIMAL: 5,
    MIN_NUMBER: 10,
    MAX_NUMBER: 100,
  },
  {
    MIN_DECIMAL: 3,
    MAX_DECIMAL: 6,
    MIN_NUMBER: 100,
    MAX_NUMBER: 1000,
  },
]

export const intDiff = [
  {
    MIN: 1,
    MAX: 1000,
  },
  {
    MIN: 100,
    MAX: 10000,
  },
  {
    MIN: 1000,
    MAX: 1000000,
  },
  {
    MIN: 10000,
    MAX: 100000000,
  },
]

export const getMultiBy = (i: number): number => {
  const multiBy = [10, 100, 1000, 10 ** Math.floor(Math.random() * (6 - 4 + 1) + 4)]
  return multiBy[i]
}

export const spaceEveryThousand = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
